module.exports = __webpack_public_path__ + "img/21.5.COD.9350a909.png";